module.exports = __webpack_public_path__ + "static/img/nearby.2d86e3c8.png";